import axios from "axios";

// Use the env backend URL only when it matches the page origin; on custom
// domains (e.g. modusadvantage.com) call same-origin so session cookies are first-party.
const envUrl = process.env.REACT_APP_BACKEND_URL;
const sameOrigin = (() => {
  try { return new URL(envUrl).origin === window.location.origin; } catch { return false; }
})();
const BACKEND_URL = sameOrigin ? envUrl : window.location.origin;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Global 401 handler: when a session expires mid-use, sign out cleanly instead
// of leaving the UI in a half-logged-in state. Auth/shared calls and public
// pages are excluded (they legitimately see 401s while logged out).
const PUBLIC_PATHS = ["/", "/login", "/pricing"];
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err.response?.status;
    const reqUrl = err.config?.url || "";
    const path = window.location.pathname;
    const isPublic = PUBLIC_PATHS.includes(path) || path.startsWith("/shared/");
    if (status === 401 && !reqUrl.includes("/auth/") && !reqUrl.includes("/shared/") && !isPublic) {
      window.location.href = "/login";
      return new Promise(() => {});
    }
    return Promise.reject(err);
  }
);
